import React, {useMemo} from 'react';

import {Dialog} from '@pb/kit-component-dialog-v2';
import {useShown} from '@pb/kit-hooks-use-shown';

import {ConfirmDeleteRoleModal} from './confirm-delete-role-modal.component';

type Props = {
    profileId: number,
    children: (params: {onShowRemoveModal: () => void, tooltip?: string}) => React.ReactNode,
    usersCounts: number,
    isPrimary: boolean,
    profileName: string,
    onDelete: () => void,
};

const SYSTEM_ROLE_MESSAGE = 'The system role cannot be deleted';
const ASSIGNED_ROLE_MESSAGE =
    'There are some users assigned to this role. Please unassign the users first to delete the role.';

export const RemoveRoleController = ({profileId, isPrimary, children, usersCounts, profileName, onDelete}: Props) => {
    const {shown: showRemoveModal, onClose: onCloseRemoveModal, onClick: onShowRemoveModal} = useShown();

    const tooltip = useMemo(() => {
        if (isPrimary) {
            return SYSTEM_ROLE_MESSAGE;
        }

        if (usersCounts !== 0) {
            return ASSIGNED_ROLE_MESSAGE;
        }

        return undefined;
    }, [isPrimary, usersCounts]);

    return (
        <>
            {children({onShowRemoveModal, tooltip})}
            <Dialog shown={showRemoveModal} setShown={onCloseRemoveModal} wrapperProps={{style: {width: 420}}}>
                <ConfirmDeleteRoleModal
                    onDelete={onDelete}
                    profileId={profileId}
                    profileName={profileName}
                    onClose={onCloseRemoveModal}
                />
            </Dialog>
        </>
    );
};
